import { render, staticRenderFns } from "./BackNavBar.vue?vue&type=template&id=1aa07d3a&scoped=true"
import script from "./BackNavBar.vue?vue&type=script&lang=js"
export * from "./BackNavBar.vue?vue&type=script&lang=js"
import style0 from "./BackNavBar.vue?vue&type=style&index=0&id=1aa07d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa07d3a",
  null
  
)

export default component.exports